import React, { useState } from "react";

export default function MetricToggle({ label, value, options, onChange }) {

  const [open, setOpen] = useState(false);

  const colors = {
    // CONDITION
    Poor: "linear-gradient(180deg, #d32f2f 0%, #b71c1c 100%)",
    Fair: "linear-gradient(180deg, #fb8c00 0%, #ef6c00 100%)",
    Good: "linear-gradient(180deg, #2e7d32 0%, #1b5e20 100%)",

    // CRITICALITY
    Low: "linear-gradient(180deg, #2e7d32 0%, #1b5e20 100%)",
    Medium: "linear-gradient(180deg, #fb8c00 0%, #ef6c00 100%)",
    High: "linear-gradient(180deg, #d32f2f 0%, #b71c1c 100%)",

    // RIGIDITY
    Flexible: "linear-gradient(180deg, #2e7d32 0%, #1b5e20 100%)",
    Moderate: "linear-gradient(180deg, #fb8c00 0%, #ef6c00 100%)",
    Fixed: "linear-gradient(180deg, #d32f2f 0%, #b71c1c 100%)"
  };


  const styles = {

    metricCol: {
      flex: 1,
      textAlign: "center",
      margin: "10px 0",
      position: "relative"          // 🔥 anchor point
    },

    metricLabel: {
      fontSize: "11px",
      fontWeight: 600,
      color: "#555",
      marginBottom: "6px"
    },

    metricPill: {
      padding: "8px 0",
      borderRadius: "6px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      background: colors[value],
      color: "#fff",
      transition: "all 0.2s ease"
    },

    popup: {
      position: "absolute",
      top: "100%",                  // 🔥 below pill
      left: "50%",
      transform: "translateX(-50%)",
      marginTop: "8px",
      background: "#111",
      padding: "12px",
      borderRadius: "10px",
      minWidth: "200px",
      boxShadow: "0 12px 30px rgba(0,0,0,0.6)",
      zIndex: 1000
    },

    option: {
      padding: "10px",
      borderRadius: "6px",
      marginBottom: "8px",
      fontSize: "13px",
      fontWeight: 600,
      color: "#fff",
      cursor: "pointer",
      textAlign: "center"
    }
  };

  return (
    <div style={styles.metricCol}>
      <div style={styles.metricLabel}>{label}</div>

      <div
        style={styles.metricPill}
        onClick={() => setOpen(!open)}
      >
        {value}
      </div>

      {open && (
        <div style={styles.popup}>
          {options.map(opt => (
            <div
              key={opt}
              style={{
                ...styles.option,
                background: colors[opt]
              }}
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
